import { IGifList, IShortUserList, IUserSearchResults } from "./types";

import AuthHttpService from "./AuthHttpService";

export default class CreatorsService extends AuthHttpService {
  public constructor(readonly url?: string) {
    super(url);
  }

  async searchCreators(params: {
    query?: string;
    order?: string;
    page?: number;
    count?: number;
    tags?: string;
    verified?: boolean;
  }): Promise<IUserSearchResults> {
    const query = new URLSearchParams();

    query.append("order", params.order ?? "trending");
    query.append("page", (params.page ?? 1).toString());

    if (params.count) {
      query.append("count", params.count.toString());
    }

    if (params.query) {
      query.append("query", params.query);
    }

    if (params.verified) {
      query.append("verified", "y");
    }

    if (params.tags) {
      query.append("tags", params.tags);
    }

    return await this.get(`v2/creators/search?${query}`);
  }

  async getNewVerifiedCreators(): Promise<IShortUserList> {
    return await this.get("v2/creators/verified");
  }

  async searchCreatorsPreviews(params: {
    query?: string;
    order?: string;
    page?: number;
    count?: number;
    tags?: string;
    verified?: boolean;
  }): Promise<IGifList> {
    const query = new URLSearchParams();

    query.append("order", params.order ?? "trending");
    query.append("page", (params.page ?? 1).toString());

    if (params.count) {
      query.append("count", params.count.toString());
    }

    if (params.query) {
      query.append("query", params.query);
    }

    if (params.verified) {
      query.append("verified", "y");
    }

    if (params.tags) {
      query.append("tags", params.tags);
    }

    return await this.get(`v2/creators/search/previews?${query}`);
  }
}
